import React from 'react';
import { Icon } from '../../../../../base/components/Icon';

import './styles.scss';

interface Props {
    isActive: boolean;
}

export const MutualIcon = ({ isActive }: Props) => {
    return (
        <div className='responses-mutual-icon'>
            <Icon
                icon='arrow-down-regular'
                color={isActive ? 'success' : 'grey'}
                size='15px'
                className='responses-mutual-icon__down'
            />
            <Icon
                icon='arrow-up-regular'
                color={isActive ? 'highlight' : 'grey'}
                size='15px'
                className='responses-mutual-icon__up'
            />
        </div>
    );
};
